import { inject, Injectable } from '@angular/core';
import { combineLatest, map, of } from 'rxjs';
import { RemoteCommandProviderService } from '../remote-command-provider.service';

@Injectable({ providedIn: 'root' })
export class ParametersIdentifierService {
  private remoteCommandProviderService = inject(RemoteCommandProviderService, { optional: true });

  parameters$ = this.remoteCommandProviderService?.parameters$ ?? of();
  subsystems$ = this.remoteCommandProviderService?.parameterSubsystems$ ?? of();
  categories$ = this.remoteCommandProviderService?.parameterCategories$ ?? of();

  pcbType$ = this.paramByIdentifiers$(1, 3);
  firmwareVersion$ = this.paramByIdentifiers$(1, 8);
  beaconId$ = this.paramIdByIdentifiers$(4, 1);
  beaconPowerId$ = this.paramIdByIdentifiers$(4, 2);
  cameraId$ = this.paramIdByIdentifiers$(14, 2);
  timezoneId$ = this.paramIdByIdentifiers$(1, 6);
  iridiumModeId$ = this.paramIdByIdentifiers$(7, 1);
  globalstarModeId$ = this.paramIdByIdentifiers$(5, 6);
  gSMModeId$ = this.paramIdByIdentifiers$(12, 4);
  ioTModeId$ = this.paramIdByIdentifiers$(19, 1);
  releaseTimeModeId$ = this.paramIdByIdentifiers$(16, 3);
  radioFiringId$ = this.paramIdByIdentifiers$(16, 6);
  releaseTimeAbsoluteId$ = this.paramIdByIdentifiers$(16, 4);
  releaseTimeRelativeId$ = this.paramIdByIdentifiers$(16, 5);
  presetPatternParameter$ = this.paramByIdentifiers$(4, 28);
  accSampleRateParameter$ = this.paramByIdentifiers$(6, 39);
  motionDataAdvAccParameter$ = this.paramByIdentifiers$(6, 33);
  motionDataAdvAccAndMagParameter$ = this.paramByIdentifiers$(20, 1);
  uhfIdTagParameter$ = this.paramByIdentifiers$(8, 7);
  uhfModeParameter$ = this.paramByIdentifiers$(3, 8);
  uhfStartTimeParameter$ = this.paramByIdentifiers$(3, 6);
  uhfEndTimeParameter$ = this.paramByIdentifiers$(3, 7);
  gpsSkipCountParameter$ = this.paramByIdentifiers$(2, 4);
  statusMessageModeParameter$ = this.paramByIdentifiers$(10, 33);
  mitModeParameter$ = this.paramByIdentifiers$(10, 13);
  vitModeParameter$ = this.paramByIdentifiers$(10, 18);
  sepModeParameter$ = this.paramByIdentifiers$(10, 24);

  private paramByIdentifiers$(subsystemIdentifier: number, parameterIdentifier: number) {
    return combineLatest([this.parameters$, this.subsystems$]).pipe(
      map(([parameters, subsystems]) => {
        const sId = subsystems.find(({ identifier }) => identifier === subsystemIdentifier)?.id;
        return parameters.find(
          ({ identifier, subsystemId }) =>
            identifier === parameterIdentifier && subsystemId === sId,
        );
      }),
    );
  }
  private paramIdByIdentifiers$(subsystemIdentifier: number, parameterIdentifier: number) {
    return combineLatest([this.parameters$, this.subsystems$]).pipe(
      map(([parameters, subsystems]) => {
        const sId = subsystems.find(({ identifier }) => identifier === subsystemIdentifier)?.id;
        const param = parameters.find(
          ({ identifier, subsystemId }) =>
            identifier === parameterIdentifier && subsystemId === sId,
        );
        return param?.id;
      }),
    );
  }
}
